import {User, UserRole} from "./model";
import UserStorage from "../../../localStorages/userStorage";
import {stringToUserRole} from "../funcs/userFuncs";

const getUserRoleFromStore = (): UserRole | null => {
    const user = UserStorage.getUser()
    if (user) {
        return stringToUserRole(user.user_role)
    }
    return null
}

export interface State {
    token: string | null
    user: User | null
    userRole: UserRole | null
    displayCurrency: string
    exchangeRate: number
    isLogInLoading: boolean
    isUserInfoUpdateLoading: boolean
    isChangePasswordLoading: boolean
}

export const initialState: State = {
    token: UserStorage.getToken(),
    user: UserStorage.getUser(),
    userRole: getUserRoleFromStore(),
    displayCurrency: UserStorage.getCurrency() ?? UserStorage.getUser()?.user_currency ?? '',
    exchangeRate: UserStorage.getExchangeRate() ?? 1,
    isLogInLoading: false,
    isUserInfoUpdateLoading: false,
    isChangePasswordLoading: false
}